function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.97 26.305H6.23a1.476 1.476 0 01-1.474-1.477V6.618h19.688v18.21a1.473 1.473 0 01-1.475 1.477zM14.6 6.617v19.688M4.756 16.46h19.688M9.678 9.898v3.282M8.038 11.54h3.28M11.319 19.742l-3.281 3.281M8.038 19.742l3.28 3.281M17.881 11.54h3.282M17.881 19.742h3.282M17.881 23.023h3.282M24.444 6.617H4.756V3.336a1.64 1.64 0 011.64-1.64h16.407a1.64 1.64 0 011.64 1.64v3.281z",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));